import { ProgressBar } from '@/components';
import { Heading, Card, CurrencyValue, Flex } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
export default function SPKDistribution() {
  const theme = useTheme();
  const data = [
    {
      name: 'Spark Foundation',
      percentage: '0.35',
      amount: '3500000000',
      color: theme.colors.sparkSpkColor
    },
    {
      name: 'Genesis Farming',
      percentage: '0.65',
      amount: '6500000000',
      color: theme.colors.sparkSavingsColor
    }
  ];

  return (
    <Card flexDirection="column" gap="s">
      <Heading size="4">SPK Genesis Distribution</Heading>

      <Flex flexDirection="column" gap="m">
        {data.map((row) => (
          <ProgressBar
            key={row.name}
            color={row.color}
            percent={row.percentage}
            text={row.name}
            additionalValue={<CurrencyValue value={row.amount} />}
          />
        ))}
      </Flex>
    </Card>
  );
}
